import GlobalSet from '~/graphql/queries/globalSet.graphql';

export const PHASE_NOMINATION = 'nomination';
export const PHASE_WAITING = 'waiting';
export const PHASE_VOTING = 'voting';
export const PHASE_JUDGING = 'judging';
export const PHASE_DONE = 'done';

export const PHASES = {
    PHASE_NOMINATION,
    PHASE_WAITING,
    PHASE_VOTING,
    PHASE_JUDGING,
    PHASE_DONE,
};

export const useHiconsStore = defineStore('hicons', () => {
    const activePhase = ref(PHASES.PHASE_NOMINATION);
    const votes = ref([]);
    const voteCount = computed(() => votes.value?.length ?? 0);
    const maxVotes = ref(4);
    const maxReached = computed(() => votes.value.length >= maxVotes.value);

    const hasVote = (id) => votes.value?.includes(id) ?? false;
    const toggle = (id) => {
        if (hasVote(id)) {
            // remove the vote
            votes.value = votes.value.filter(v => v !== id);
        } else {
            if (maxReached.value) {
                // ignore more votes, max was reached.
                return;
            }

            // add a new vote
            votes.value.push(id);
        }
    };

    // IIFE to fetch the HiconsPhase from the server.
    (async() => {
        const { variables: defaultVariables } = useDefaultVariables();
        const variables = computed(() => {
            return {
                ...defaultVariables.value,
                handle: 'hiconsphase'
            };
        });

        const { data } = await useAsyncQuery({
            query: GlobalSet,
            variables
        });

        // set it or keep it as is of no value found.
        activePhase.value = data.value?.globalSet?.hiconsphase ?? activePhase.value;
    })();

    return {
        activePhase,
        votes,
        voteCount,
        maxVotes,
        maxReached,
        hasVote,
        toggle
    };
});
